export const en = {
  // Common
  "common.back": "Back",
  "common.cancel": "Cancel",
  "common.noItems": "No items",
  "common.loading": "Loading...",
  // Header
  "nav.features": "Features",
  "nav.howItWorks": "How It Works",
  "nav.pricing": "Pricing",
  "nav.faq": "FAQ",
  "nav.testimonials": "Showcase",
  "nav.contact": "Contact",
  "button.getStarted": "Get Started",
  "button.loading": "Loading...",

  // Auth related
  "auth.signIn": "Sign In",
  "auth.redirecting": "Redirecting...",
  "auth.continueWithGoogle": "Continue with Google",
  "auth.continueWithGithub": "Continue with GitHub",
  "auth.or": "OR",
  "auth.consent.prefix": "By proceeding, you agree to our",
  "auth.consent.terms": "Terms",
  "auth.consent.and": "and",
  "auth.consent.privacy": "Privacy Policy",

  // Site Title
  "site.title": "Communicate to Win",
  "site.title.first": "Communicate",
  "site.title.second": "to Win",
  "site.title.translated": "沟通制胜", // 中文标题

  // Hero Section
  "hero.title": "AI-Powered Communication Assistant",
  "hero.subtitle":
    "Transform your conversations with intelligent, context-aware responses that help you communicate more effectively in any situation.",
  "hero.cta.primary": "Start Free Trial",
  "hero.cta.secondary": "Watch Demo",
  // New Hero Showcase keys
  "hero.cta.tryNow": "Get Started Free",
  "hero.cta.learnMore": "Learn More",
  "hero.cta.getStarted": "Get Started Free",
  "hero.preview.primary": "Polish Tone",
  "hero.preview.secondary": "Translate",
  "hero.preview.tone": "Friendly",
  "hero.preview.target": "Client",
  "hero.hook": "Join thousands of users improving their communication every day.",
  // Stats
  "stats.users": "Users",
  "stats.replies": "Replies",
  "stats.languages": "Languages",

  // Main Title
  "main.title": "Turn Every Reply Into An Opportunity",

  // Footer Section - 新增
  "footer.company": "Company",
  "footer.product": "Product",
  "footer.support": "Support",
  "footer.legal": "Legal",
  "footer.contactSupport": "Contact Support",
  "footer.helpCenter": "Help Center",
  "footer.apiDocs": "API Documentation",
  "footer.statusPage": "Status Page",
  "footer.privacyPolicy": "Privacy Policy",
  "footer.termsOfService": "Terms of Service",
  "footer.cookiePolicy": "Cookie Policy",
  "footer.refundPolicy": "Refund Policy",
  "footer.copyright": "© 2025 DOUBLEWIND LTD. All rights reserved.",
  "footer.supportLabel": "Support",

  // Features Section
  "features.badge": "Powerful Features",
  "features.title": "Everything You Need for Better Communication",
  "features.subtitle":
    "Comprehensive tools designed to make every conversation more effective and professional.",
  "features.scenario.title": "Scenario Templates",
  "features.scenario.description":
    "Pre-built templates for workplace, personal, academic, and professional communications.",
  "features.custom.title": "Custom Inputs",
  "features.custom.description":
    "Paste any message or content and get contextually appropriate responses.",
  "features.instant.title": "Cut reply time by 90%",
  "features.instant.description":
    "Get AI-crafted replies in few seconds. No waiting, just results.",
  "features.copy.title": "One-click Copy & Share",
  "features.copy.description":
    "Copy responses instantly or share them directly from the platform.",

  // How It Works Section
  "howItWorks.badge": "How It Works",
  "howItWorks.title": "Three Simple Steps to Better Communication",
  "howItWorks.subtitle":
    "Our streamlined process makes it easy to generate professional responses for any situation.",
  "howItWorks.step1.title": "Select Scenario",
  "howItWorks.step1.description":
    "Choose the communication scenario that best fits your needs.",
  "howItWorks.step2.title": "Paste Content",
  "howItWorks.step2.description":
    "Add the message or content you need to respond to.",
  "howItWorks.step3.title": "Get AI Response",
  "howItWorks.step3.description":
    "Receive a professional, contextual response in seconds.",

  // Pricing Section
  "pricing.title": "Pricing",
  "pricing.subtitle": "Choose the plan that fits your communication needs",
  "pricing.plan.free": "Free",
  "pricing.plan.pro": "Pro",
  "pricing.plan.business": "Enterprise",
  "pricing.free.price": "$0",
  "pricing.pro.price": "$9.99",
  "pricing.business.price": "$29.99",
  "pricing.period": "/month",
  "pricing.free.description": "Perfect for trying out our service",
  "pricing.pro.description": "Ideal for professionals and frequent users",
  "pricing.business.description": "For teams and organizations",
  "pricing.popular": "Most Popular",
  "pricing.free.feature1": "10 replies per month",
  "pricing.free.feature2": "Basic scenario",
  "pricing.free.feature3": "Define & Use templates",
  "pricing.free.feature4": "Historical reply records",
  "pricing.pro.feature1": "200 replies per month",
  "pricing.pro.feature2": "Basic+Custom scenario",
  "pricing.pro.feature3": "Define & Use templates",
  "pricing.pro.feature4": "Historical reply records",
  "pricing.pro.feature5": "Advanced customization",
  "pricing.business.feature1": "Unlimited replies",
  "pricing.business.feature2": "Team collaboration",
  "pricing.business.feature3": "Basic+Custom scenario",
  "pricing.business.feature4": "Define & Use templates",
  "pricing.business.feature5": "Historical reply records",
  "pricing.business.feature6": "Advanced customization",
  "pricing.cta.trial": "Start Free Trial",
  "pricing.cta.subscribe": "Subscribe",
  "pricing.cta.contact": "Contact Sales",
  "pricing.cta.current": "Current Plan",
  "pricing.currentPlan": "Current Plan:",
  "pricing.endDate": "Current plan end date:",
  "pricing.autoRenewalDate": "Current plan auto-renewal date:",
  "pricing.answersLeft": "Replies left:",
  "pricing.planName.free": "Free Plan",
  "pricing.planName.proMonthly": "Pro Plan-Monthly",
  "pricing.planName.proYearly": "Pro Plan-Yearly",
  "pricing.planName.maxMonthly": "Enterprise Plan-Monthly",
  "pricing.planName.maxYearly": "Enterprise Plan-Yearly",
  "pricing.autoRenews": "Your replies count auto-renews on:",
  "pricing.needMore": "Need more replies?",
  "pricing.upgradeBelow": "Upgrade your plan below",
  "pricing.doNotRollOver": "Unused replies don't roll over",
  "pricing.willCancelOn": "Will cancel on:",
  "pricing.downgradeScheduled": "Downgrade scheduled. Will switch to",
  "pricing.on": "on:",
  "pricing.upgradeImmediateTitle": "Plan upgraded",
  "pricing.upgradeImmediateDesc": "Your new plan is now active.",
  "pricing.downgradeScheduledTitle": "Downgrade scheduled",
  "pricing.downgradeScheduledDesc": "Your plan will change at next renewal.",
  "pricing.cancelScheduledTitle": "Cancellation scheduled",
  "pricing.cancelScheduledDesc": "Your plan will end at the period end date.",
  "pricing.cancelResumedTitle": "Cancellation removed",
  "pricing.cancelResumedDesc": "Your subscription will continue renewing.",
  "pricing.cancelPendingDowngrade": "Cancel",
  "pricing.pendingDowngradeCanceledTitle": "Pending downgrade canceled",
  "pricing.pendingDowngradeCanceledDesc": "Your plan will remain unchanged.",
  "pricing.pendingDowngradeCancelFailedTitle": "Cancel failed",
  "pricing.pendingDowngradeCancelFailedDesc": "Couldn't cancel the pending downgrade. Please try again.",
  "pricing.cancelPendingDowngradeProcessing": "Processing...",
  "pricing.scheduled": "Scheduled",
  "pricing.processing": "Processing...",
  "pricing.getMoreReplies": "Get More Replies",
  "pricing.oneTimeTitle": "Get more replies to your account",
  "pricing.oneTimeAmountLabel": "Amount (USD)",
  "pricing.repliesUnit": "Replies",
  "pricing.oneTimeNotice": "The number of replies you purchase is valid for the current month cycle. An active paid subscription is required to use them and unused replies do not roll over.",
  "pricing.cancel": "Cancel",
  "pricing.proceed": "Proceed",
  "pricing.confirmUpgradeTitle": "Confirm Upgrade",
  "pricing.confirmDowngradeTitle": "Confirm Downgrade",
  "pricing.confirmUpgradeDesc": "You're about to upgrade your plan. The change takes effect immediately and a prorated charge (or credit) may apply.",
  "pricing.confirmDowngradeDesc": "You're about to schedule a downgrade. Your current features remain until the end of the current billing period.",
  "pricing.downgradeEffectNote": "Downgrade does not refund the current cycle.",
  "pricing.downgradeApplyNextCycle": "The new plan will start automatically at renewal.",
  "pricing.confirmCancel": "Back",
  "pricing.confirmProceedUpgrade": "Upgrade Now",
  "pricing.confirmProceedDowngrade": "Schedule Downgrade",

  // FAQ Section
  "faq.title": "Frequently Asked Questions",
  "faq.subtitle": "Everything you need to know about communicate2win",
  "faq.q1": "What communication scenarios are supported?",
  "faq.a1":
    "We support workplace communications, personal relationships, academic correspondence, customer service, sales outreach, and many other scenarios. Our AI adapts to the context and tone required for each situation.",
  "faq.q2": "How fast are the responses generated?",
  "faq.a2":
    "Our AI generates responses in few seconds. We prioritize speed without compromising quality, ensuring you get professional responses instantly.",
  "faq.q3": "Can I cancel my subscription anytime?",
  "faq.a3":
    "Yes, you can cancel your subscription at any time. There are no long-term commitments, and you can downgrade or upgrade your plan as needed.",
  "faq.q4": "Is my data secure and private?",
  "faq.a4":
    "Yes, we implement comprehensive security measures including encryption, access controls, and regular security audits. Your input content and generated responses are stored as part of your user history to enable features like response review and template creation. You can delete your history data at any time through your account settings.",
  "faq.q5": "What if I run out of Replies?",
  "faq.a5":
    "Free users must wait until the next monthly cycle for their reply quota to refresh. After upgrading to Pro, if you run out of Replies you can purchase additional one‑time Replies; these extra Replies are valid only for the current month cycle. Enterprise users have unlimited Replies.",
  "faq.q6": "What languages are supported?",
  "faq.a6":
    "Currently, we support English with plans to expand to Spanish, French, German, and other major languages. The AI can handle multilingual communications effectively.",

  // Testimonials Section
  "testimonials.title": "Communications Showcase",
  "testimonials.subtitle":
    "Public messages, emails and AI-polished responses to spark your own",
  "testimonials.sarah.name": "Sarah Johnson",
  "testimonials.sarah.title": "Marketing Director",
  "testimonials.sarah.quote":
    "communicate2win has transformed how I handle client communications. The responses are professional and save me hours every week.",
  "testimonials.michael.name": "Michael Chen",
  "testimonials.michael.title": "Sales Manager",
  "testimonials.michael.quote":
    "The workplace scenario templates are incredibly accurate. My response rate has improved by 40% since using this tool.",
  "testimonials.emily.name": "Emily Rodriguez",
  "testimonials.emily.title": "Customer Success Lead",
  "testimonials.emily.quote":
    "Perfect for handling difficult customer situations. The AI understands context and tone perfectly.",
  "testimonials.more": "Click gallery to explore full showcase",

  // Interface Elements
  "interface.generating": "Generating Response...",
  "interface.generate": "Generate AI Response",
  "interface.processing": "Processing...",
  "interface.advancedOptions": "Advanced Options",
  "interface.clearInput": "Clear Input",
  "interface.clearDescription": "Clear Description",
  // Marquee / Logos
  "marquee.trusted": "Partners / Support",
  "marquee.aria": "Brand logos",

  // History and Showcase
  "history.shareToShowcase": "Share to Showcase",
  "history.showcased": "Showcased",
  "history.shareConfirm":
    "Share this post to the Showcase? This action can't be undone unless you delete the post.",
  "history.sharedBy": "Shared by:",
  "interface.copy": "Copy",
  "interface.share": "Share",
  "interface.shareResponse": "Share Response",
  "interface.shareNative": "Share via System",
  "interface.shareEmail": "Email",
  "interface.copyShareText": "Copy with Link",
  "interface.shareTextCopied": "Response and link copied to clipboard.",
  "interface.ready": "Ready to Generate",
  "interface.enterMessage":
    "Enter your message content and select a scenario to get started with AI-powered responses.",
  "interface.fast": "Fast",
  "interface.accurate": "Accurate",
  "interface.professional": "Professional",
  "interface.translation": "Translation",
  "interface.responseDescription":
    "Here's a thoughtful and professional response tailored to the context:",
  "interface.multipleOptions": "Multiple response options:",
  "interface.option": "Option",
  "interface.viewOriginal": "View original",
  "interface.originalMessage": "Original message",
  "interface.noContent": "No content available",

  // Placeholders
  "placeholder.message":
    "Paste the message you're replying to, email content, or text you received...",

  // Dropdowns
  "dropdown.useTemplates": "Use Templates",
  "dropdown.scenario": "No Scenario",
  "dropdown.target": "No Target",
  "dropdown.tone": "No Tone",

  // Scenario Options
  "scenario.email": "Email",
  "scenario.message": "Message",
  "scenario.workplace": "Workplace",
  "scenario.school": "School",
  "scenario.home": "Home",
  "scenario.business": "Business",
  "scenario.academic": "Academic",
  "scenario.social": "Social",
  "scenario.formal": "Formal",
  "scenario.casual": "Casual",
  "scenario.professional": "Professional",
  "scenario.personal": "Personal",
  "scenario.customerService": "Customer Service",
  "scenario.interview": "Interview",
  "scenario.presentation": "Presentation",

  // Target Options
  "target.lover": "Lover",
  "target.friend": "Friend",
  "target.boss": "Boss",
  "target.colleague": "Colleague",
  "target.classmate": "Classmate",
  "target.parents": "Parents",
  "target.child": "Child",
  "target.teacher": "Teacher",
  "target.student": "Student",
  "target.client": "Client",
  "target.customer": "Customer",
  "target.stranger": "Stranger",
  "target.family": "Family",
  "target.sibling": "Sibling",
  "target.neighbor": "Neighbor",
  "target.mentor": "Mentor",
  "target.supplier": "Supplier",
  "target.serviceProvider": "Service Provider",
  "target.partner": "Partner",
  "target.subordinate": "Subordinate",

  // Tone Options
  "tone.humorous": "Humorous",
  "tone.serious": "Serious",
  "tone.happy": "Happy",
  "tone.angry": "Angry",
  "tone.mischievous": "Mischievous",
  "tone.polite": "Polite",
  "tone.casual": "Casual",
  "tone.formal": "Formal",
  "tone.friendly": "Friendly",
  "tone.confident": "Confident",
  "tone.apologetic": "Apologetic",
  "tone.enthusiastic": "Enthusiastic",

  // Status Messages
  "status.copied": "Copied!",
  "status.copyDescription": "Response copied to clipboard.",
  "status.copyWithTranslationDescription":
    "Response and translation copied to clipboard.",
  "status.success": "Response generated successfully. ",
  "status.successWithTranslation": "Response generated with translation.",
  "status.successWithoutTranslation": "Response generated successfully.",
  "status.error": "Generation failed",
  "status.errorDescription": "Failed to generate response. Please try again.",
  "status.enterContent": "Please enter content",
  "status.enterContentDescription": "Add the message you want to reply to.",

  // Pro/Max subscriber restrictions
  "restriction.descriptionOptional": "Description (optional)",
  "restriction.descriptionLabel":
    "Description (Only for Pro / Enterprise subscribers)",
  "restriction.proMaxOnly": "* Only for Pro / Enterprise subscribers",
  "restriction.desPrompt":
    "Enter context, background information, or specific requirements that can help generate better responses...",

  // Demo functionality for non-logged-in users
  "demo.title": "Select a message to reply to",
  "demo.option1": "Sales opener (cold outreach)",
  "demo.option2": 'Handling a "your price is high" probe',
  "demo.option3": "Interview self-introduction (30-second version)",
  "demo.option4": "Email reply",
  "demo.option5": 'Follow-up for a "read-but-no-reply" prospect',
  "demo.option6": "Elevator pitch (30 seconds)",
  "demo.runDemo": "Run Demo",
  "demo.inputContent": "Input Content:",
  "demo.scenario": "Scenario:",
  "demo.target": "Target:",
  "demo.tone": "Tone:",
  "demo.description": "Description:",

  // Showcase Page
  "showcase.title": "Communications Showcase",
  "showcase.subtitle": "Discover inspiring AI-powered communications shared by our community",
  "showcase.userPrefix": "Public communications by",
  "showcase.backAll": "Back to All Showcase",
  "showcase.sortBy": "Sort by:",
  "showcase.sort.newest": "Newest First",
  "showcase.sort.oldest": "Oldest First",
  "showcase.sort.scenario": "By Scenario",
  "showcase.sort.target": "By Target",
  "showcase.sort.tone": "By Tone",
  "showcase.filter.scenario": "Scenario:",
  "showcase.filter.target": "Target:",
  "showcase.filter.tone": "Tone:",
  "showcase.filter.all": "All",
  "showcase.loading": "Loading showcase...",
  "showcase.loadingUser": "Loading user communications...",
  "showcase.loadingMore": "Loading more...",
  "showcase.none.userTitle": "No public communications yet",
  "showcase.none.globalTitle": "No showcase items yet",
  "showcase.none.userDesc": "This user hasn't shared any communications to the showcase yet.",
  "showcase.none.globalDesc": "Be the first to share your AI communication to the showcase!",
  "showcase.messageDetails": "Message Details",
  "showcase.field.date": "Date",
  "showcase.field.scenario": "Scenario",
  "showcase.field.target": "Target",
  "showcase.field.tone": "Tone",
  "showcase.originalMessage": "Original Message",
  "showcase.description": "Description",
  "showcase.aiResponse": "AI Response",

  // Templates
  "templates.saveAsTemplate": "Save as Template",
  "templates.saved": "Template Saved",
  "templates.saveSuccess": "Template saved successfully",
  "templates.title": "My Templates",
  "templates.new": "New Template",
  "templates.loading": "Loading...",
  "templates.none": "No templates found",
  "templates.name": "Name",
  "templates.scenario": "Scenario",
  "templates.target": "Target",
  "templates.tone": "Tone",
  "templates.description": "Description",
  "templates.save": "Save",
  "templates.saving": "Saving...",
  "templates.delete": "Delete Template",
  "templates.deleteConfirm": "Delete this template?",
  "templates.deleteFailed": "Failed to delete template",
  "templates.nameRequired": "* Please enter template name",
  "templates.deleteSuccess": "Template deleted successfully",

  // History Modal additions
  "history.messageDetails": "Message Details",
  "history.messageDetailsDesc": "View and manage your message details, including the original input and AI-generated response.",
  "history.field.date": "Date",
  "history.field.scenario": "Scenario",
  "history.field.target": "Target",
  "history.field.tone": "Tone",
  "history.originalMessage": "Original Message",
  "history.aiResponse": "AI Response",
  "history.description": "Description",
  "history.listTitle": "Message History",
  "history.listDesc": "Browse, filter, and manage your conversation history. Click on any message to view details.",
  "history.sortBy": "Sort by:",
  "history.sort.newest": "Newest First",
  "history.sort.oldest": "Oldest First",
  "history.sort.scenario": "By Scenario",
  "history.sort.target": "By Target",
  "history.sort.tone": "By Tone",
  "history.filter.scenario": "Scenario:",
  "history.filter.target": "Target:",
  "history.filter.tone": "Tone:",
  "history.filter.all": "All",
  "history.loading": "Loading history...",
  "history.loadingMore": "Loading more...",
  "history.none": "No messages found",
  "history.showing": "Showing {current} of {total} messages",
  "history.allLoaded": "All messages loaded",
  "history.scrollMore": "Scroll down for more",
  "history.loadMoreButton": "Load More",
  "history.deleteMessage": "Delete Message",
  "history.deleting": "Deleting...",
  "history.deleteSuccess": "Message record deleted successfully",
  "history.deleteFailed": "Failed to delete message record, please try again",
  "history.confirmDeleteTitle": "Confirm Delete",
  "history.confirmDeleteSubtitle": "This action cannot be undone",
  "history.confirmDeleteDesc": "Are you sure you want to delete this message record?",
  "history.confirmDeleteAction": "Confirm Delete",
  "history.shareTitle": "Share to Showcase",
  "history.shareSubtitle": "Make this message public",
  "history.sharing": "Sharing...",
  "history.confirmShareAction": "Confirm Share",
  "history.shareSuccess": "Message shared to showcase successfully",
  "history.shareFailed": "Failed to share to showcase, please try again",
  "templates.saveFailed": "Failed to save template",

  // User Menu
  "userMenu.myAccount": "My Account",
  "userMenu.history": "History",
  "userMenu.templates": "Templates",
  "userMenu.signOut": "Sign Out",
  
  // Hero Showcase / Demo Tabs / Previews
  "hero.preview.aiReply": "AI Reply Preview",
  "hero.preview.scenarioLabel": "Scenario",
  "hero.headline": "AI-Powered Communication Assistant",
  "hero.subheadline": "Transform rough ideas into polished, context-aware replies in seconds.",
  // Demo short tab titles (mapped from demo option ids)
  "demo.shortTitle.salesOpener": "Sales opener",
  "demo.shortTitle.priceObjection": "Price probe",
  "demo.shortTitle.interviewIntro": "Interview intro",
  "demo.shortTitle.emailReply": "Email reply",
  "demo.shortTitle.followUp": "Follow-up",
  "demo.shortTitle.elevatorPitch": "Elevator pitch",
  // Demo path / response overlay
  "demoTabs.pathPrefix": "demo",
  "demoTabs.response": "response",
  "demoTabs.inputPrompt": "INPUT PROMPT",
  "demoTabs.context": "CONTEXT",
  "demoTabs.description": "Description",
  "demoTabs.generate": "Generate",
  "demoTabs.aiOutput": "AI OUTPUT",
  "demoTabs.sample": "sample",
  "demoTabs.streaming": "Streaming tokens...",
  "preview.section.scenarioTemplates.title": "Scenario & Templates",
  "preview.section.scenarioTemplates.subtitle": "Quickly pick a scenario or apply a saved template. Templates prefill description / target / tone so you enter high-quality generation instantly.",
  "preview.section.customInputs.title": "Custom Inputs",
  "preview.section.customInputs.subtitle": "Core input + optional description + advanced Scenario / Target / Tone selectors. Combine freely for context-aware results.",
  "preview.section.cutReplyTime.title": "Cut Reply Time by 90%",
  "preview.section.cutReplyTime.subtitle": "Compare manual drafting vs AI assist. Parallel options + built-in translation slash revision loops.",
  "preview.section.copyShare.title": "One-click Copy & Share",
  "preview.section.copyShare.subtitle": "Multiple options laid out with unified top actions: copy all / share / per-option copy. Translation appended automatically.",
  "preview.templates.my": "My Templates",
  "preview.templates.new": "New",
  "preview.manualFlow": "Manual Flow",
  "preview.aiAssisted": "AI Assisted",
  // Manual flow bullet steps
  "preview.manualFlow.step1": "Plan structure & tone",
  "preview.manualFlow.step2": "Draft opening / delete & rewrite",
  "preview.manualFlow.step3": "Adjust politeness & grammar",
  "preview.manualFlow.step4": "Lookup wording + verify translation",
  "preview.manualFlow.step5": "Paste into target app",
  "preview.copyAll": "Copy All",
  "preview.share": "Share",
  "preview.enPlusTranslation": "EN + Translation",
  "preview.translationAppendNote": "(*) Translation is appended automatically when copying all.",
  "preview.field.scenario": "Scenario",
  "preview.field.target": "Target",
  "preview.field.tone": "Tone",
  "preview.auto": "Auto",
  "preview.step.pasteOrTemplate": "Paste request or pick template",
  "preview.step.optionalDescription": "(Optional) add description / scenario",
  "preview.step.pickOption": "Pick one generated option",
  "preview.step.copyShareTranslate": "One-click copy / share / translate",
  "preview.time.manual": "5–8 min",
  "preview.time.ai": "30–40 sec"
};
